import { render } from "./BackerCenterPreviewSkeleton.vue?vue&type=template&id=66c7e99f"
import script from "./BackerCenterPreviewSkeleton.vue?vue&type=script&lang=js"
export * from "./BackerCenterPreviewSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__